import 'bootstrap/dist/css/bootstrap.min.css';

// fonts
import '@fontsource/nunito';
